module.exports = __webpack_public_path__ + "img/logic.f8ac50c0.jpg";